module.exports = __webpack_public_path__ + "img/hn.e9233ea9.svg";